import { ISelectables } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';

export class Selectables implements ISelectables {
  @ignore(true)
  backgroundColor;
  @ignore(true)
  bgColor;
  @ignore(true)
  borderColor;
  @ignore(true)
  color;
  @ignore(true)
  label = '';
  @ignore(true)
  value = '';
  selected = false;
}
